import React from 'react'
import  './Header.scss'
import {Link, withRouter} from 'react-router-dom'
import {Icon, Image} from 'semantic-ui-react'
import logoTransparent from '../../img/logotransparente.png'
import db, { auth } from '../../utils/firebase'
import { AppBar, Toolbar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import Buscador from '../Search/Buscador'
import {map} from 'lodash'
import { useAuth } from '../../context/authContext'


 function Headers() {

    const{user}=useAuth()
    
    const classes = useStyles()
    const [show,setShow] = React.useState(false)
    const [showList, setShowList] = React.useState(false)
    
       
    const esconderHeader = () =>{
        if(window.scrollY >100) {
            setShow(true)

        }else{
            setShow(false)
        }
    }


    React.useEffect(() =>{
        window.addEventListener("scroll", esconderHeader)
        //return ()=> window.removeEventListener("scroll", esconderHeader)
    },[])

   const signOut = () =>{
    auth.signOut()

   }

   const list = () =>{
       setShowList(!showList)
   }

    return (
        
        <AppBar position="sticky" elevation={0} className={`${classes.transparent} ${show && classes.root}`} >
            <Toolbar className={classes.toolbar} >

                

                <div className="lista-home" >
                    <Icon onClick={list} name="list" size="large" />
                    <Link to="/" >
                        <img src={logoTransparent} alt="" />
                    </Link>
                </div>
                <Link to="/" >
                
                    <div className={classes.toolbar} >
                        <img src={logoTransparent} alt="" className={classes.logo} />
                    </div>
                    
                </Link>
                       <div className={showList ? "list-home-icon" : "list"} id="list" >
                           
                            <Link to="/" ><h3 onClick={() => setShowList(false)} >Inicio</h3></Link>     
                            <Link to="/peliculas" ><h3 onClick={() => setShowList(false)} >Peliculas</h3></Link>     
                            <Link to="/series"><h3 onClick={() => setShowList(false)} >Series y Novelas</h3></Link>
                               <h3 onClick={() => setShowList(false)} >Novedades</h3>
                           
                       </div>
                       

                

                <div  className="profile" >
                       <Buscador
                       />
                    <Link  to="/profile" >
                        <Image src={user.photoURL} className={classes.profile} />
                    </Link>
                    <Icon name="power" size="big" onClick={signOut} />
                </div>

            </Toolbar>
            

        </AppBar>

        
    )
}

export default withRouter(Headers)

const useStyles = makeStyles((theme) => ({
    
    root: {
        backgroundColor:"#141414",
        top: 0,
        left: 0,
        right: 0,
        display: "flex",
        '@media (max-Width: 768px)':{
            display:"inline-flex"
        }
        
        
    },
    transparent: {
        backgroundColor: "transparent",
        top: 0,
        left: 0,
        right: 0,

    },
    toolbar:{
        display: "inline-flex",
        justifyContent:"space-between",
        letterSpacing:"2px",
        margin: "0 20px",

        '@media (max-Width: 768px)':{
            margin: "0 10px",
            display:"inline",
            right:"0",
            left:"0"

            
            
        }

      
    },
    list:{
        
     
        
    },
    logo:{
        marginRight: "10px",
        width: "auto",
        height: "30px",
        '@media (max-Width: 768px)':{
            
           display:"none"
            
            
            
        }
       
    },
    profile:{
        height:"40px",
        width: "40px",
        '@media (max-Width: 768px)':{
          
            
        
    }
}

}
))
